import { render } from "./start-page.vue?vue&type=template&id=58100588"
import script from "./start-page.vue?vue&type=script&lang=js"
export * from "./start-page.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__